import type { FC, ReactNode } from "react";

import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { CircularProgress } from "@privacy/ui";

export const PAGE_PADDING_X = "24px";

export const PAGE_PADDING_Y = "24px";

export const PageWrapper: FC<{ children: ReactNode; sx?: SxProps }> = ({ sx, children }) => {
  return <Box sx={{ px: [1, PAGE_PADDING_X], py: PAGE_PADDING_Y, ...sx }}>{children}</Box>;
};

export const PageTitle: FC<{
  title: string;
  subTitle?: string;
  wrap?: boolean;
  wrapperSx?: SxProps;
}> = ({ title, subTitle, wrap = false, wrapperSx }) => {
  return (
    <Stack sx={{ whiteSpace: wrap ? "normal" : "nowrap", ...wrapperSx }}>
      <Typography variant="h1" sx={{ fontWeight: 600, fontSize: theme => theme.typography.pxToRem(32) }}>
        {title}
      </Typography>
      {subTitle && (
        <Typography
          sx={{
            mt: 1,
            whiteSpace: wrap ? "normal" : "nowrap",
            fontSize: theme => theme.typography.pxToRem(14),
            color: theme => theme.palette.text.tertiary,
          }}
        >
          {subTitle}
        </Typography>
      )}
    </Stack>
  );
};

export const PageSpinner = () => (
  <Stack
    sx={{
      height: "70vh",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      transform: "translateY(-10%)",
    }}
  >
    <CircularProgress delay={1000} />
  </Stack>
);
